module.exports = __webpack_public_path__ + "media/images/austrian/confirmation/confirmation-card2x-121f38196267734a3a8c4c1ea1cf6b6f.jpg";